import { Component, OnInit } from '@angular/core';
import { ConceptTreeListViewComponent } from '../concept-tree-list-view/concept-tree-list-view.component';
import { PimTemplateProperties } from 'gung-list';

@Component({
  selector: 'lib-concept-tree-table-view',
  templateUrl: './concept-tree-table-view.component.html',
  styleUrls: ['./concept-tree-table-view.component.css'],
  standalone: false
})
export class ConceptTreeTableViewComponent extends ConceptTreeListViewComponent {
  constructor() {
    super();
  }

  public trackByFn(index: number) {
    return index;
  }

  getDisplayName(headerKey: PimTemplateProperties){
    let displayName = !!headerKey.displayName && headerKey.displayName != "" ? headerKey.displayName : headerKey.translationKey;

    return displayName;
  }

}
